import React from "react";
import "./footer.css";
import { Container, Row, Col, ListGroupItem, ListGroup } from "reactstrap";
import { Link } from "react-router-dom";
import logo from "../../assets/images/therusticpaths.png";
// import img from '../../assets/images/tripadvisor.png'

const quick__links = [
  {
    path: "/",
    display: "Home",
  },
  {
    path: "/about-us",
    display: "About",
  },
  // {
  //   path: "/tours",
  //   display: "Tours",
  // },
  {
    path: "/faq",
    display: "FAQ's",
  },
];
const quick__links2 = [
  {
    path: "/tour-packages",
    display: "Tour Packages",
  },
  {
    path: "/tour-packages/jaipur-tour-packages/jaipur-sightseeing-day-tour",
    display: "Jaipur Sightseeing Day Tour",
  },
  {
    path: "/car-rental",
    display: "Car Rental",
  },
  {
    path: "/contact-us",
    display: "Contact Us",
  },
];
const quick__links3 = [
  {
    path: "/destinations/Rajasthan/jodhpur",
    display: "Jodhpur",
  },
  {
    path: "/destinations/Rajasthan/udaipur",
    display: "Udaipur",
  },
  {
    path: "/destinations/Rajasthan/jaisalmer",
    display: "Jaisalmer",
  },
  {
    path: "/destinations",
    display: "Know More ...",
  },
];
const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="footer">
      <Container>
        <Row>
          <Col lg="3">
            <div className="logo">
              <img src={logo} alt="" />
              {/* <p>
                From chauffeured rides to personalized tours, we've got you
                covered. <br /> Your dream adventure starts here!
              </p> */}
              <div className="social__links d-flex align-items-center gap-4">
                <span>
                  <a
                    href="https://www.youtube.com/channel/UCZkMu4NQxTp3DMekpKO6oCA"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="ri-youtube-fill"></i>
                  </a>
                </span>

                <span>
                  <a
                    href="https://www.facebook.com/therusticpaths/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="ri-facebook-box-line"></i>
                  </a>
                </span>
                <span>
                  <a
                    href="https://instagram.com/therusticpaths/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="ri-instagram-line"></i>
                  </a>
                </span>
                <span>
                  <a
                    href="https://www.tripadvisor.com/Attraction_Review-g304555-d10807588-Reviews-The_Rustic_Paths-Jaipur_Jaipur_District_Rajasthan.html"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fa fa-tripadvisor"></i>
                  </a>
                </span>
              </div>
            </div>
          </Col>

          <Col lg="2">
            <h5 className="footer__link-title">Discover</h5>
            <ListGroup className="footer__quick-links">
              {quick__links.map((item, index) => (
                <ListGroupItem key={index} className="ps-0 border-0">
                  <Link to={item.path}>{item.display}</Link>
                </ListGroupItem>
              ))}
            </ListGroup>
          </Col>
          <Col lg="2">
            <h5 className="footer__link-title">Quick Links</h5>
            <ListGroup className="footer__quick-links">
              {quick__links2.map((item, index) => (
                <ListGroupItem key={index} className="ps-0 border-0">
                  <Link to={item.path}>{item.display}</Link>
                </ListGroupItem>
              ))}
            </ListGroup>
          </Col>

          <Col lg="2">
            <h5 className="footer__link-title">Travel Destinations</h5>
            <ListGroup className="footer__quick-links">
              {quick__links3.map((item, index) => (
                <ListGroupItem key={index} className="ps-0 border-0">
                  <Link to={item.path}>{item.display}</Link>
                </ListGroupItem>
              ))}
            </ListGroup>
          </Col>

          <Col lg="3">
            <h5 className="footer__link-title">Contact Us</h5>
            <ListGroup className="footer__quick-links">
              <ListGroupItem className="ps-0 border-0 d-flex align-items-center gap-3">
                <h6 className="mb-0 d-flex align-items-center gap-2">
                  <span>
                    <i className="ri-map-pin-fill"></i>
                  </span>
                  Address:
                </h6>
                <p className="mb-0">
                The Rustic Paths, H NO 49 PHOOL BAG, Near Gas Agency, Amer, Rajasthan 302028.
                </p>
              </ListGroupItem>
              <ListGroupItem
                className="ps-0 border-0 d-flex align-items-center gap-3"
                onClick={() => {
                  const emailIntent = "mailto:info@therusticpaths.com";
                  if (window.confirm(`Open email intent: ${emailIntent}?`)) {
                    window.location.href = emailIntent;
                  }
                }}
              >
                <h6 className="mb-0 d-flex align-items-center gap-2">
                  <span>
                    <i className="ri-mail-line"></i>
                  </span>
                  Email:
                </h6>
                <p className="pen mb-0">info@therusticpaths.com</p>
              </ListGroupItem>
              <ListGroupItem
                className=" ps-0 border-0 d-flex align-items-center gap-3"
                onClick={() => {
                  window.location.href = "tel:+91-7297075173";
                }}
              >
                <h6 className="mb-0 d-flex align-items-center gap-2">
                  <span>
                    <i className="ri-phone-fill"></i>
                  </span>
                  Mobile Number:
                </h6>
                <p className="pen mb-0">+91-7297075173</p>
              </ListGroupItem>
            </ListGroup>
          </Col>

          <Col lg="12" className="text-center pt-5">
            <p className="copyright">
              Copyright {year}, All Rights Reserved by The Rustic Paths.
              <span className="separator"> | </span>
              <Link to="/privacy-policy" style={{ textDecoration: "none" }}>
                Privacy Policy
              </Link>
              {/* Use Link for routing */}
              <span className="separator"> | </span>
              <Link to="/terms-of-use" style={{ textDecoration: "none" }}>
                Terms of Use
              </Link>
              {/* Use Link for routing */}
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
